import React from 'react';

const ArmyRules = ({ armyRules: armyRules }) => {
  
if (armyRules === null)
    return <div className="space-y-4  mt-4">No Army Rules Found</div>;

    return <div className="space-y-4  mt-4">{armyRules}</div>;
};

export default ArmyRules;
